import Vue from 'vue';
/* eslint-disable */ 
/* eslint no-shadow: ["error", { "allow": ["state"] }] */
const state = {
  pageData: {
    fields: [],
    section_buttons: [],
    add_buttons: [],
    page_name: '',
  }, // List of `pageData`
};

const getters = {
  pageData(state) {
    return state.pageData;
  },
};

const mutations = {
  updatePageData(state, newPageData) {
    if (!newPageData) { // Reset `pageData` (i.e. upon entering a section)
      state.pageData = {
        fields: [],
        add_buttons: [],
        section_buttons: [],
        page_name: '',
      };
    }

    // TODO: HACK: Modify the button's `section` to match the section it belongs to since the API is unable
    if (newPageData.add_buttons) {
      /* eslint no-param-reassign: ["error", { "props": false }] */

      // TODO: HACK: Modify the button's `section` to match the section it belongs to since the API is unable
      newPageData.add_buttons.forEach((addButton, i) => {
        if (addButton.name === 'AddClaim') { // TODO: Use config value
          newPageData.add_buttons[i].section = 'Previous Claims';
          newPageData.section_buttons.push(newPageData.add_buttons[i]);
        }
      });
    }

    // TODO: HACK: Modify the button's `section` to match the section it belongs to since the API is unable
    if (newPageData.section_buttons) {
      /* eslint no-param-reassign: ["error", { "props": false }] */
      let modifiedSectionName = '';

      newPageData.section_buttons.forEach((sectionButton, i) => {
        if (sectionButton.section === 'Occupant_1') { // TODO: Use config value
          // TODO: HACK: Search and store the value of the section that the button's `section` needs to be set to
          newPageData.fields.forEach((field, j) => {
            if (field.section.indexOf('(Co-Applicant)') !== -1) { // TODO: Use config values
              /**
               * TODO: HACK: Rename the section to be consistent. It is originally like "[first name] [last name] (Co-Applicant)"
               * but since the API returns erroneous data upon "Remove Co-applicant", the data is not able to update properly.
               * This can be removed once the API sends proper data from the "Remove Co-Applicant" endpoint with each of the
               * Co-Applicant fields having their `section` value of "Co-Applicant".
               */
              // modifiedSectionName = field.section;
              modifiedSectionName = '(Co-Applicant)';
              newPageData.fields[j].section = '(Co-Applicant)';
            }
          });

          newPageData.section_buttons[i].section = modifiedSectionName; // TODO: Use config value
        }
      });
    }

    Object.keys(newPageData).forEach((item) => {
      if (item === 'fields') {
        let combinedFields = [];
        const oldFields = state.pageData.fields;
        const newFields = newPageData.fields;

        state.pageData.fields.forEach((oldField, i) => { // TODO: Refactor better than n^2
          newPageData.fields.forEach((newField, j) => {
            if (oldField.field_name === newField.field_name) {
              oldFields[i] = newField; // Replace the old field w/ the new field
              newFields.splice(j, 1); // Remove that new field from the list of new fields
            }
          });
        });

        combinedFields = oldFields.concat(newFields); // Attach any leftover newFields to the end
        Vue.set(state.pageData, 'fields', combinedFields);
      } else if (item === 'section_buttons') {
        let combinedProperties = [];
        const oldProperties = state.pageData[item];
        const newProperties = newPageData[item];
        state.pageData[item].forEach((oldProperty, i) => { // TODO: Refactor better than n^2
          newPageData[item].forEach((newProperty, j) => {
            if (oldProperty.name === newProperty.name) {
              oldProperties[i] = newProperty; // Replace the old property w/ the new property
              newProperties.splice(j, 1); // Remove that new property from the list of new properties
            }
          });
        });
       combinedProperties = oldProperties.concat(newProperties); // Attach any leftover properties to the end
      //Adding visible property from front-end to hide/show  SetAsPrimaryApplicant button TODO:Section-button visible property should come from backend.
      for(var index=0; index<combinedProperties.length; index++)
       {

        const apiEndpoint =combinedProperties[index].on_click;
        if(apiEndpoint.indexOf('/rules/AddCoApplicant') === 0 )
        { for(var index2=0; index2<combinedProperties.length; index2++)
          {
          if(combinedProperties[index2].name==='SetAsPrimaryApplicant')
           combinedProperties[index2].visible=false;
          }
        }
        else if(apiEndpoint.indexOf('/rules/RemoveCoApplicant') === 0 )
        for(var index2=0; index2<combinedProperties.length; index2++)
        {
        if(combinedProperties[index2].name==='SetAsPrimaryApplicant')
         combinedProperties[index2].visible=true;
        }
       }
        Vue.set(state.pageData, 'section_buttons', combinedProperties);
      } else {
        Vue.set(state.pageData, item, newPageData[item]);
      }
    });
  },
};

const actions = {
  setPageData({ commit }, pageData) {
    commit('updatePageData', pageData);
  },
};

/**
 * export module to main store.js
 */
export default {
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/updatePageData.js